import { Box, Container, Typography } from "@mui/material";

import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import DryCleaningIcon from "@mui/icons-material/DryCleaning";
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import cardBg from "../../assets/images/services_showcase_bg.png";
import serviceBg from "../../assets/images/a_s_c.png";
import serviceBgm from "../../assets/images/a_s_c_m2.png";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import PrintIcon from "@mui/icons-material/Print";
import HomeIcon from "@mui/icons-material/Home";
const services = [
  {
    title: "Dry Cleaning",
    desc: "Expert dry cleaning for shirts, suits, blazers, dresses, formal wear and delicate fabrics.",
    icon: <DryCleaningIcon />,
  },

  {
    title: "Laundry & Steam Pressing",
    desc: "Professional wash & fold, laundry care, steam pressing and everyday garment maintenance.",
    icon: <LocalLaundryServiceIcon />,
  },

  {
    title: "Alterations & Repairs",
    desc: "Pant hemming, zipper replacement, seam repairs, fittings and professional garment alterations.",
    icon: <ContentCutIcon />,
  },

  {
    title: "Wedding Dress Care",
    desc: "Specialized cleaning, alterations, restoration and preservation for wedding gowns and bridal wear.",
    icon: <WorkspacePremiumIcon />,
  },

  {
    title: "Shoe & Handbag Care",
    desc: "Shoe cleaning, sneaker restoration, shoe repair, handbag cleaning and luxury item care.",
    icon: <CheckroomIcon />,
  },

  {
    title: "Custom Printing",
    desc: "Custom t-shirts, uniforms, corporate branding, event merchandise and promotional apparel.",
    icon: <PrintIcon />,
  },

  {
    title: "Rug & Carpet Cleaning",
    desc: "Deep rug cleaning, stain removal, odour treatment and professional carpet care services.",
    icon: <AutoAwesomeIcon />,
  },

  {
    title: "Home Essentials Care",
    desc: "Comforter cleaning, cushion care, bedding, curtains and household fabric cleaning services.",
    icon: <HomeIcon />,
  },
];
export default function ServiceShowcase() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        backgroundImage: { xs: `url(${serviceBgm})`, md: `url(${serviceBg})` },

        backgroundSize: "cover",

        backgroundPosition: "center",

        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        {/* HEADING */}

        <Box
          sx={{
            textAlign: "center",

            maxWidth: "900px",

            mx: "auto",
          }}
        >
          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Our Services
          </Box>

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              lineHeight: 1.05,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            We Care For
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Everything You Wear
            </Box>
          </Typography>

          <Typography
            sx={{
              mt: 2,

              color: "#64748B",

              maxWidth: "700px",

              mx: "auto",

              lineHeight: 1.8,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            From everyday laundry and business attire to wedding dresses,
            footwear and branded apparel, our team provides premium care for
            every item.
          </Typography>
        </Box>

        {/* CARDS */}

        <Box
          sx={{
            mt: { xs: 4, md: 7 },

            display: "flex",

            flexWrap: "wrap",

            justifyContent: "center",

            gap: {
              xs: 1.5,
              md: 2.5,
            },
          }}
        >
          {services.map((item, index) => (
            <Box
              key={index}
              sx={{
                flex: {
                  xs: "1 1 calc(50% - 8px)",
                  md: "1 1 calc(33.333% - 16px)",
                },

                maxWidth: {
                  xs: "calc(50% - 8px)",
                  md: "calc(33.333% - 16px)",
                },

                minHeight: {
                  xs: 170,
                  md: 190,
                },

                p: {
                  xs: 2,
                  md: 2.5,
                },

                position: "relative",

                overflow: "hidden",

                borderRadius: "24px",

                backgroundImage: `
          // linear-gradient(
          // rgba(255,255,255,.92),
          // rgba(248,251,255,.88)
          // ),
          url(${cardBg})
        `,

                backgroundSize: "cover",

                backgroundPosition: "center",

                border: "1px solid rgba(255,255,255,.85)",

                boxShadow: "0 12px 35px rgba(0,87,255,.08)",

                transition: ".35s",

                "&::before": {
                  content: '""',

                  position: "absolute",

                  left: 0,

                  top: 14,

                  bottom: 14,

                  width: "4px",

                  borderRadius: "20px",

                  background: "linear-gradient(180deg,#0057FF,#1DB6FF)",
                },

                "&:hover": {
                  transform: "translateY(-6px)",

                  boxShadow: "0 20px 50px rgba(0,87,255,.15)",
                },
              }}
            >
              {/* ICON */}

              <Box
                sx={{
                  width: {
                    xs: 48,
                    md: 56,
                  },

                  height: {
                    xs: 48,
                    md: 56,
                  },

                  borderRadius: "16px",

                  display: "flex",

                  alignItems: "center",

                  justifyContent: "center",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  color: "#fff",

                  boxShadow: "0 12px 30px rgba(0,87,255,.25)",

                  mb: 1.8,

                  "& svg": {
                    fontSize: {
                      xs: 24,
                      md: 28,
                    },
                  },
                }}
              >
                {item.icon}
              </Box>

              {/* TITLE */}

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#07122F",

                  lineHeight: 1.3,

                  fontSize: {
                    xs: "16px",
                    md: "20px",
                  },
                }}
              >
                {item.title}
              </Typography>

              {/* DESC */}

              <Typography
                sx={{
                  mt: 1,

                  color: "#64748B",

                  lineHeight: 1.7,

                  fontSize: {
                    xs: "12px",
                    md: "14px",
                  },
                }}
              >
                {item.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
